import styled from '@emotion/styled';
import Dialog from '@/components/Dialog';
import mediaQuery from '@/lib/styling/mediaQuery';

const AttachmentDialog = styled(Dialog)({
  '.MuiDialog-paper': {
    width: 700,
    minWidth: 700,
    maxWidth: '100%',
    minHeight: 200,
    maxHeight: 'calc(100% - 300px)',
    [mediaQuery(764)]: {
      minWidth: 0,
    },
  },
});

export default AttachmentDialog;
